<template>
  <div class="login background">
    <!-- <img class="background" src="@/assets/background-2.jpg" alt /> -->
    <a href="http://chance4talents.de" class="back-to-website">
      <!-- <v-icon color="white">chevron_left</v-icon> -->
      <span class="btn"> Zur Website </span>
    </a>

    <v-card class="login-wrapper" v-if="!send" dark>
      <h3>
        Weshalb
        {{
          user_data.userType === 'teams' ? 'habt ihr euren' : 'hast du deinen'
        }}
        Account gelöscht?
      </h3>
      <br />
      <p>
        Wir möchten uns gerne durch
        {{ user_data.userType === 'teams' ? 'euer' : 'dein' }} Feedback verbessern.
      </p>
      <v-radio-group v-model="reason">
        <v-radio v-for="n in reasons" class="reason" color="green" :key="n" :value="n">
          <template v-slot:label>
            <div>{{ n }}</div>
          </template>
        </v-radio>
      </v-radio-group>
      <v-textarea
        v-if="reason === 'Es gibt einen anderen Grund.'"
        color="green"
        v-model="other_reason"
        placeholder="Beschreibe ihn..."
      ></v-textarea>
      <div class="column">
        <Button
          @click="sendFeedback"
          :loading="$store.state.loading"
          rounded
          :label="'Feedback senden'"
          >Senden</Button
        >
      </div>
    </v-card>
    <v-card v-else class="login-wrapper" dark>
      <h1>Vielen Dank für dein Feedback.</h1>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios';
import Button from '@/components/Button';
import { cloudFunctions } from '../config';

export default {
  components: {
    Button,
  },
  data: () => ({
    reasons: [],
    other_reason: '',
    reason: '',
    send: false,
    switch1: true,
    loading: false,
  }),

  computed: {
    user_data() {
      return this.$store.state.user_data;
    },
  },

  created() {
    this.reasons = [
      `Die Funktionalität und/oder das Design der Plattform gefällt ${
        this.user_data.userType === 'teams' ? 'uns' : 'mir'
      } nicht.`,
      `Die Plattform hat nicht ${
        this.user_data.userType === 'teams' ? 'unsere' : 'meine'
      } Erwartungen erfüllt bzw. ${
        this.user_data.userType === 'teams' ? 'haben wir uns' : 'habe ich mir'
      } etwas anderes vorgestellt.`,
      `${
        this.user_data.userType === 'teams' ? 'Wir haben' : 'Ich habe'
      } kein passendes Match gefunden.`,
      `${
        this.user_data.userType === 'teams' ? 'Wir haben' : 'Ich habe'
      } ein passendes Match gefunden und ${
        this.user_data.userType === 'teams' ? 'benötigen' : 'benötige'
      } die Plattform nicht mehr.`,
      this.user_data.userType === 'trainer' || this.user_data.userType === 'player'
        ? 'Die Swipe-Packages sind mir zu teuer bzw. bin ich nicht bereit dafür zu bezahlen.'
        : this.user_data.userType === 'teams'
        ? 'Die Saisontickets sind uns zu teuer bzw. sind wir nicht bereit dafür zu bezahlen.'
        : 'Die Match-Abos sind mir zu teuer bzw. bin ich nicht bereit dafür zu bezahlen.',
      'Es gibt einen anderen Grund.',
    ];
  },

  methods: {
    async sendFeedback() {
      const data = {
        cancel_reason: this.reason,
        other_reason: this.other_reason,
        type: this.user_data.userType,
      };
      const json = JSON.stringify(data);
      this.$store.state.loading = true;
      try {
        await axios({
          method: 'post',
          url: `${cloudFunctions}/takeFeedback`,
          headers: {
            'content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
          data: json,
        });
        this.$store.state.loading = false;
        this.send = true;
        this.$router.push({ name: 'login' });
      } catch (e) {
        this.$store.state.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  display: flex;
  align-items: center;
  margin-top: 15px;
  .divider {
    margin: 15px;
  }
}
.divider {
  width: 100%;
}
.card-text {
  text-align: left;
}

.reason {
  border-bottom: 1px solid rgba(129, 128, 128, 0.274);
  padding-bottom: 15px;
}

.login {
  min-height: 100vh;
  overflow: hidden;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  a {
    text-decoration: none;
  }
}
.login-btn {
  margin-bottom: 15px;
}

.background {
  // position: fixed;
  // right: 0;
  // top: 0;
  // max-height: 100vh;
  // min-width: 100vw;
  height: 100%;
  width: 100%;

  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);

  background: #303030; /* Old browsers */
  background: -moz-linear-gradient(left, #303030 0%, #000000 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    left,
    #303030 0%,
    #000000 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to left,
    #303030 0%,
    #000000 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#303030', endColorstr='#000000',GradientType=0 ); /* IE6-9 */
}

.team-link {
  position: absolute;
  color: white;
  right: 10px;
  top: 10px;
}

.team-link-2 {
  position: absolute;
  color: white;
  right: 10px;
  top: 40px;
}

.login-content {
  position: relative;
  color: white;
}

.login-wrapper {
  margin-top: 50px;
  margin-bottom: 50px;
  h1 {
    margin-bottom: 15px;
  }
  max-width: 500px;
  min-height: 400px;
  display: flex;
  width: 90%;
  flex-direction: column;
  border-radius: 20px;
  padding: 25px;
}

.register {
  color: black;
  font-weight: 500;
  text-decoration: none;
  margin-top: 15px;
  margin-bottom: 20px;
}
.forgotPW {
  position: relative;
  color: rgb(134, 134, 134);
  margin-top: 25px;
  font-weight: 500;
  text-decoration: none;
}

.back-to-website {
  position: absolute;
  left: 10px;
  top: 10px;
  color: white;
  font-weight: bold;
  display: flex;
  align-items: center;

  .btn {
    color: white;
    background: rgb(23, 161, 60);
    padding: 6px 10px;
    border-radius: 5px;
  }
}
</style>
